import {Button, Toolbar, Typography, TextField} from "@mui/material";
import {ID} from "../../../../types/global.d";
import {Add, } from "@mui/icons-material";
import {useNavigate, useLocation} from "react-router";
import React from "react";
import {useStateSession} from "../../../../hooks/useAuth";
import { Trans } from "@lingui/react/macro";
import {useGetTimberStorageQuery} from "../../../apis/TimberStorage.api";
import {PrimaryTimberStorage} from "../../../types/models/TimberStorage";
import {useGetCuttingQuery} from "../../../apis/Cutting.api";
import {PrimaryCutting} from "../../../types/models/Cutting";
import {CuttingState} from "../../../types/models/CuttingState.d";
import {cuttingStateEditCheck} from "../../../stateChecks.ts";

type IFormProps = {
    showAdd: boolean,
    timberStorageId?: ID,
    };

const LogListHeader = (props: IFormProps)  => {

    const {showAdd, onSearchTerm, ...query} = props;
    
    const session = useStateSession()
    const navigate = useNavigate();
    const routeLocation = useLocation();
    
    const onAdd = React.useCallback((e: any) => {
        e.stopPropagation()
        if (routeLocation.pathname.endsWith('logs')) {
            navigate(`add`, {relative: 'route', state: query})
        } else {
            navigate(`logs/add`, {relative: 'route', state: query})
        }
    }, [navigate, routeLocation])

    const { data: storage } = useGetTimberStorageQuery(PrimaryTimberStorage.fromId(props?.timberStorageId), {skip: !props?.timberStorageId})
    const { data: cutting } = useGetCuttingQuery(PrimaryCutting.fromId(storage?.cuttingId), {skip: !storage?.cuttingId})

    return (
        <Toolbar
            sx={ {
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
            } }
        >
            <Typography
                sx={ { flex: '1 1 100%' } }
                variant="h6"
                component="div"
                data-testid="Log-list-title"
            >
                <Trans>Logs</Trans>
            </Typography>
            { showAdd && session.hasPermission('', 'applications/timber/entities/Logs/write/view') &&
                cuttingStateEditCheck(cutting?.state)
                &&
                <Button data-testid="Log-add-button" variant="contained" color="success" startIcon={<Add />} onClick={onAdd}>
                    <Trans>Add</Trans>
                </Button>
            }
        </Toolbar>
    )
}
export default LogListHeader;
